export default "__VITE_ASSET__9b236c2c__"